export default "__VITE_ASSET__Co0GNqf2__"